import { call, put, takeEvery } from 'redux-saga/effects';
import { targetedCatalogActionCreators, TargetedCatalogActionKeys, UpdateTargetedCatalogSection } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { updateSection } from '../targetedCatalogApi';
import { ITargetedCatalogSectionBase } from '../targetedCatalogInterfaces';

function* updateTargetedCatalogSectionSaga(action: UpdateTargetedCatalogSection) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<ITargetedCatalogSectionBase[]> = yield call(updateSection, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(targetedCatalogActionCreators.setSectionMins(response.value));
  }
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateTargetedCatalogSection() {
  yield takeEvery(TargetedCatalogActionKeys.UPDATE_TARGETED_CATALOG_SECTION, updateTargetedCatalogSectionSaga);
}
